import React, {Component} from 'react';

//controller
import MemberControllerAPI from '../../controllers/API/MemberControllerAPI.js';

//css
import styles from '../../static/css/pageStyleModules/memberEditAndAddMode.module.scss';

//settingFile
import {validation} from '../../static/js/settingFile/validationData.js';

import { CSSTransition } from 'react-transition-group';

import FaceIconBaseComponent from '../faceIconComponents/FaceIconBaseComponent.js';
import MemberIconSelectComponent from '../components/inputComponent/MemberIconSelectComponent.js';
import ManipulateHeader from '../layouts/header/ManipulateHeader.js';

export default class MemberEditAndAddMode extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAddMode : false,

            memberDataForEdit:{},

            iconSelectModalIsOpen:false,

            memoTextLimit:validation.memberMemoMax,

            isDeleteDialogShown:false,

        }
        this.nameInputRef = React.createRef();
    }

    componentWillMount = () => {
        
        if(this.props.memberId !== null && this.props.memberId !== undefined){
            //editMode
            //idをもとに、データをget
            MemberControllerAPI.show(this.props.memberId)
            .then((result) => {
                const dataForEdit = JSON.parse(JSON.stringify(result.data))
                this.setState({memberDataForEdit:dataForEdit});
            })
            .catch((error) => {
                console.log(error);
            })

        }else {
            //addMode
            this.setState({
                isAddMode:true,
                memberDataForEdit:{ 
                    name:'',
                    memo:'',
                    head:'basic',
                    eyes:'basic',
                    eyeblows:'none',
                    mouth:'basic',
                    face_ex:'',
                    color:'hsl(6,77%,62%)',
                    order:null,
                    twitter_id:''
                }
            })
            
        }
    }

    componentDidMount = () => {        
        if(this.props.memberId === null){
            this.nameInputRef.current.focus();
        }
    }

    //双方向データバインディングの書き方
    changeMemberName = (event) => {
        //ネストされたstate要素の一部分だけ変更するときはこんな感じ
        const copyToOverWrite = JSON.parse(JSON.stringify(this.state.memberDataForEdit));        
        copyToOverWrite.name = event.target.value;
        
        this.setState({
            memberDataForEdit:copyToOverWrite
        })
    }

    rewriteIconData = (newHead,newEyes,newEyeblows,newMouth,newColor) => {
        let memberDataToRewrite = this.state.memberDataForEdit;
        memberDataToRewrite.head = newHead;
        memberDataToRewrite.eyes = newEyes;
        memberDataToRewrite.eyeblows = newEyeblows;
        memberDataToRewrite.mouth = newMouth;
        memberDataToRewrite.color = newColor;
        this.setState({memberDataForEdit:memberDataToRewrite,iconSelectModalIsOpen:false});
    }

    changeMemberMemo = (event) => {
        const copyToOverWrite = JSON.parse(JSON.stringify(this.state.memberDataForEdit));        
        copyToOverWrite.memo = event.target.value;
        
        this.setState({
            memberDataForEdit:copyToOverWrite
        })
    }


    submitMember = () => {
        
        if(this.state.memberDataForEdit.name.length === 0){
            this.props.onInfoDisplayCall('cancel','#999999','名前がありません');
            return;
        }

        if(this.state.memberDataForEdit.memo !== undefined 
            && this.state.memberDataForEdit.memo.length > this.state.memoTextLimit){
            this.props.onInfoDisplayCall('cancel','#999999','文字数オーバーです');
            return ;
        }

        MemberControllerAPI.store(this.state.memberDataForEdit)
        .then((result) => {
            this.props.onInfoDisplayCall('facedHeart','hsl(6,77%,62%)','保存しました');
            this.props.onCancelButtonClick();
            this.props.onSubmitDone(result.data.id);
        })
        .catch((error) => {
            console.log(error.data);
        })
    }

    toggleDeleteDialog = () => {
        this.setState({isDeleteDialogShown:!this.state.isDeleteDialogShown});
    }

    render() {

        const textMaxedOutStyle = () => {
            if(this.state.memberDataForEdit.memo !== undefined 
               && this.state.memberDataForEdit.memo.length > this.state.memoTextLimit){
                return {color:'hsl(6,77%,62%)',transition:'color .2s'}
            }else{
                return {color:'#999999',transition:'color .2s'};
            }
        }

        return (
            <div className={styles['inputBaseArea']}>
               <div className={styles['submitArea']}>
                <ManipulateHeader
                leftIcon={'cancel'}
                leftIconColor={'#999999'}
                onLeftButtonClick={() => this.props.onCancelButtonClick()}
                rightIcon={'submit'}
                rightIconColor={'hsl(93,54%,43%)'}
                onRightButtonClick={this.submitMember} 
                />
              </div>

              <div className={styles['inputArea']}>

                <div className={styles['nameInputArea']}>
                  <input 
                  className="thanksLogInput"
                  type="text" placeholder="名前を入力" maxLength={validation.memberNameMax}
                  value={this.state.memberDataForEdit.name !== undefined ? this.state.memberDataForEdit.name : ''} 
                  onChange={this.changeMemberName} 
                  ref={this.nameInputRef}
                  />
                </div>

                <div className={styles['iconInputButton'] + ' thanksLogButton touchActiveDark'}
                onClick={() => {this.setState({iconSelectModalIsOpen:true})}} >
                  <div className={styles['iconDisplay']}>
                    <FaceIconBaseComponent 
                    head={this.state.memberDataForEdit.head} 
                    eyes={this.state.memberDataForEdit.eyes} 
                    eyeblows={this.state.memberDataForEdit.eyeblows} 
                    mouth={this.state.memberDataForEdit.mouth} 
                    fillColor={this.state.memberDataForEdit.color}/>
                  </div>
                </div>

                <div className={styles['memoInputArea']}>
                  <textarea placeholder="メモ..." rows="5"
                  className="thanksLogInput"
                  value={this.state.memberDataForEdit.memo !== undefined ? this.state.memberDataForEdit.memo : ''} 
                  onChange={this.changeMemberMemo} />
                  <div className={styles['textCounter']} style={textMaxedOutStyle()}>
                    <span>{this.state.memberDataForEdit.memo !== undefined ? this.state.memberDataForEdit.memo.length : 0}</span>
                    <span> / </span>
                    <span>{this.state.memoTextLimit}</span>
                  </div>
                </div>

              </div>

              <CSSTransition
              in={this.state.iconSelectModalIsOpen}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <div className={styles['iconSelectModalBase']}>
                  <div className={styles['iconSelectModal']}>
                    <MemberIconSelectComponent 
                    memberData={this.state.memberDataForEdit}
                    onEnterClick={this.rewriteIconData}
                    onCancelClick={() => {this.setState({iconSelectModalIsOpen:false})}} />
                  </div>
                </div>
              </CSSTransition>

            </div>
        )
    }
}
